export const profileViewStyle = {
    topActions: {
      display: "flex",
      alignItems: "start",
      paddingBottom: "30px",
      paddingTop: "50px",
      width: "60%",
    },
    infoTitle: {
      display: "flex",
      alignItems: "start",
      flexGrow: 1,
    },
    userImage: {
      width: "5vw",
      height: "5vw",
      maxWidth: "100px",
      maxHeight: "100px",
      position: "relative",
      marginRight: "25px",
    },
    saveButton: {},
    bottomActions: {
      width: "60%",
      display: "flex",
      justifyContent: "space-between",
      padding: "10px 0",
    },
    formContent: {
      width: "60%",
    },
    selectField: {
      marginBottom: "15px",
    },
  };